import Duck from 'extensible-duck';
import Immutable from 'immutable';
import get from 'lodash/get';

import requestsManager from 'lib/requestsManagerAxios'; // eslint-disable-line

const errorToSnackbarMessage = errorObject => {
  if (errorObject === null) return 'Unable to save';

  const firstKey = Object.keys(errorObject)[0];

  let legibileKey;
  switch (firstKey) {
    case 'facebook_url':
      legibileKey = 'Facebook URL ';
      break;
    case 'twitter_url':
      legibileKey = 'X URL ';
      break;
    case 'instagram_url':
      legibileKey = 'Instagram URL ';
      break;
    default:
      legibileKey = '';
  }

  const firstMessage = get(errorObject, [firstKey]);
  return `${legibileKey} ${firstMessage}`;
};

export default new Duck({
  namespace: 'organization-config',
  store: 'settings',
  types: [
    'CHANGE_ORGANIZATION',
    'CLOSE_SNACKBAR',
    'UPDATE_ORGANIZATION',
    'UPDATE_ORGANIZATION_PENDING',
    'UPDATE_ORGANIZATION_REJECTED',
    'UPDATE_ORGANIZATION_FULFILLED',
    'UPDATE_USER',
    'UPDATE_USER_PENDING',
    'UPDATE_USER_REJECTED',
    'UPDATE_USER_FULFILLED',
  ],
  initialState: Immutable.Map({
    devToolsOn: true,
    setIsFetching: false,
    setIsSaving: false,
    snackbarMessage: '',
    snackbarOpen: false,
    $$organization: {},
    $$organizationError: Immutable.Map(),
    $$user: {},
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      case types.CHANGE_ORGANIZATION:
        return $$state.mergeDeep({
          $$organization: {
            [payload.field]: payload.value,
          },
        });
      case types.CLOSE_SNACKBAR:
        return $$state.merge({
          snackbarMessage: '',

          snackbarOpen: false,
        });
      case types.UPDATE_USER_PENDING:
      case types.UPDATE_ORGANIZATION_PENDING:
        return $$state.merge({ setIsSaving: true });
      case types.UPDATE_ORGANIZATION_REJECTED:
        return $$state.merge({
          setIsSaving: false,
          snackbarOpen: true,
          snackbarMessage: errorToSnackbarMessage(payload.response.data),
          $$organizationError: Immutable.fromJS(payload.response.data || {}),
        });
      case types.UPDATE_ORGANIZATION_FULFILLED:
        return $$state.merge({
          setIsSaving: false,
          snackbarOpen: true,
          snackbarMessage: 'Saved',
          $$organizationError: Immutable.Map(),
          $$organization: Immutable.fromJS(payload.data),
        });
      case types.UPDATE_USER_REJECTED:
        return $$state.merge({
          setIsSaving: false,
          snackbarOpen: true,
          snackbarMessage: 'Something went wrong. Try refreshing.',
        });
      case types.UPDATE_USER_FULFILLED:
        return $$state.merge({
          setIsSaving: false,
          snackbarOpen: true,
          snackbarMessage: 'Saved',
          $$user: Immutable.fromJS(payload.data),
        });
      default:
        return $$state;
    }
  },
  selectors: {
    organizationError: $$state => $$state.get('$$organizationError').toJS(),
  },
  creators: ({ types }) => ({
    changeOrganization: (field, value) => ({
      type: types.CHANGE_ORGANIZATION,
      payload: { field, value },
    }),
    closeSnackbar: () => ({ type: types.CLOSE_SNACKBAR }),
    updateOrganization: organization => ({
      type: types.UPDATE_ORGANIZATION,
      payload: requestsManager.patch('/admin/organization/update', {
        organization,
      }),
    }),
    updateUser: user => ({
      type: types.UPDATE_USER,
      payload: requestsManager.patch('/admin/users', { user }),
    }),
  }),
});
